export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

export const getAvatarUrl = (avatar: any) => {
  if (!avatar || typeof avatar !== 'string') return avatar;
  if (avatar.startsWith('http')) return avatar;
  const baseUrl = process.env.REACT_APP_API_URL_BACKEND?.replace('/api/v1', '') || 'http://localhost:3333';
  return `${baseUrl}/files/${avatar}`;
}
